<script>
    export let difficulty;
    let difficultytype = difficulty;
    let difficultycolor = '';
    if(difficultytype == 'Beginner') {
        difficultycolor = 'cut2dDesktop';
    } else if(difficultytype == 'Intermediate') {
        difficultycolor = 'primary';
    } else if(difficultytype == 'Advanced') {
        difficultycolor = 'aspire';
    } else {
        difficultycolor = 'black';
    }
</script>

<div class="vec-inline-flex vec-bg-{difficultycolor}/40 vec-p-1 vec-px-2 vec-text-xs vec-rounded vec-uppercase vec-my-3 vec-items-center">
    <div class="vec-flex vec-w-9 vec-h-3 vec-flex-row vec-mr-2 vec-relative ">
        <div class="vec-rounded-l-full vec-w-3 vec-h-full vec-bg-white vec-border vec-border-{difficultycolor}"></div>
        <div class="vec-ml-[-1px] vec-w-3 vec-h-full {(difficultytype == 'Intermediate' || difficultytype == 'Advanced')?'vec-bg-white':''} vec-border vec-border-{difficultycolor}"></div>
        <div class="vec-ml-[-1px] vec-rounded-r-full vec-w-3 vec-h-full {(difficultytype == 'Advanced')?'vec-bg-white':''} vec-border vec-border-{difficultycolor}"></div>
    </div>
    {difficulty}
</div>
